import { Button } from '@repo/ui';

import { useRetryAccess } from '@/hooks/auth/use-retry-access';

/**
 * Reads the session again, so someone who has just been granted a role carries on from here
 * instead of signing out and back in. If nothing has changed it says so, rather than doing nothing.
 */
export function TryAgainButton() {
  const { mutate: retry, isPending, isSuccess } = useRetryAccess();

  return (
    <div className="flex flex-col items-center gap-2">
      <Button onClick={() => retry()} disabled={isPending}>
        {isPending ? 'Checking…' : 'Try again'}
      </Button>

      {isSuccess ? (
        <p role="status" className="text-sm text-muted-foreground">
          Still no access. Once someone grants you a role, try again.
        </p>
      ) : null}
    </div>
  );
}
